import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { IVerifyEmailRequest, IVerifyEmailResponse } from '../models/verify-email.model';


export const verifyEmailRequest = createAction(
  '[Authentication] verify email request',
  props<{ request: IVerifyEmailRequest }>()
);

export const verifyEmailRequestSuccess = createAction(
  '[Authentication] verify email response',
  props<{ response: IVerifyEmailResponse }>()
);

export const verifyEmailRequestFailure = createAction(
  '[Authentication] verify email failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);